import { render, staticRenderFns } from "./Activitiesmanage.vue?vue&type=template&id=5bcc641b&scoped=true&"
import script from "./Activitiesmanage.vue?vue&type=script&lang=js&"
export * from "./Activitiesmanage.vue?vue&type=script&lang=js&"
import style1 from "./Activitiesmanage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc641b",
  null
  
)

export default component.exports